import { Flex, ActionButton } from '@cycle-app/ui';
import { UndoIcon, CloseIcon } from '@cycle-app/ui/icons';

import { Label, Title } from './LabelWithReset.styles';

type LabelWithResetProps = {
  label: string;
  id?: string;
  showReset: boolean;
  showRemove?:boolean;
  reset: VoidFunction;
  remove?: VoidFunction;
};

export const LabelWithReset = ({
  id, showReset, label, reset, showRemove, remove,
}: LabelWithResetProps) => {
  return (
    <Flex $align="center" $justify="space-between">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      {id && <Label htmlFor={id}>{label}</Label>}
      {!id && <Title>{label}</Title>}
      <Flex $align="center" $gap={4}>
        {showRemove && (
          <ActionButton size="M" tooltip="Remove" tooltipPlacement="top" onClick={remove}>
            <CloseIcon size={12} />
          </ActionButton>
        )}
        {showReset && (
          <ActionButton size="M" tooltip="Reset" tooltipPlacement="top" onClick={reset}>
            <UndoIcon size={14} />
          </ActionButton>
        )}
      </Flex>
    </Flex>
  );
};
